<template>
    <div>
        <masternav/>
        <!--  -->
      
      <b-nav class="navlinks ">
        <b-nav-item router-link to="/">
          <span class="navtext ">{{$t('leasing.nav1')}}</span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">{{$t('leasing.nav2')}}</span>
        </b-nav-item>
      </b-nav>
      <div>
        <img 
            style="width:100%"
            class="" 
            src="/img/stpcars.png"/>
      </div>
      <!--  -->
      <div class="m-1">
        <p class="titlequestion text-center">{{$t('leasing.l1')}}</p>
        <div class="ml-5 mr-5 navtext2 ">
          <p class="titleterm "></p>
          <h6>
            {{$t('leasing.l2')}}
          </h6>
        </div>
        <br>
        <p class="titlequestion  text-center">{{$t('leasing.l3')}}</p>
        <div class="m-5 d-none d-sm-none d-md-block">
          <b-row class="ml-5 mr-5">
              <b-col 
              md="4" 
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/costo.jpg');"
              >
              <h3 class="imgtitle text-center">{{$t('leasing.l4')}}</h3>
              </b-col>
              <b-col 
              md="4" 
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/tecnico.jpg');"
              >
              <h3 class="imgtitle text-center">{{$t('leasing.l5')}}</h3>
              </b-col>
              <b-col 
              md="4"
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/reemplazo.jpg');"
              >
              <h3 class="imgtitle text-center">{{$t('leasing.l6')}}</h3>
              </b-col>
          </b-row>
          <b-row class="ml-5 mr-5">
              <b-col 
              md="4" 
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/siniestros.jpg');"
              >
                <h3 class="imgtitle text-center">{{$t('leasing.l7')}}</h3>
              </b-col>
              <b-col md="4" class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/asistencia.jpg');"
              >
                <h3 class="imgtitle text-center">{{$t('leasing.l8')}}</h3>
              </b-col>
              <b-col md="4" class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/legales.jpg');"
              >
                <h3 class="imgtitle text-center">{{$t('leasing.l9')}}</h3>
              </b-col>
          </b-row>
        </div>
        <!-- mobile -->
        <div class="d-md-none d-lg-none d-xl-none">
          <b-row class="m-3">
              <b-col 
              md="4" 
              class=" zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/costo.jpg');"
              >
              <h3 class="imgtitle text-center">{{$t('leasing.l4')}}</h3>
              </b-col>
              <b-col 
              md="4" 
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/tecnico.jpg');"
              >
              <h3 class="imgtitle text-center">{{$t('leasing.l5')}}</h3>
              </b-col>
              <b-col 
              md="4"
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/reemplazo.jpg');"
              >
              <h3 class="imgtitle text-center">{{$t('leasing.l6')}}</h3>
              </b-col>
          </b-row>
          <b-row class="m-3">
              <b-col 
              md="4" 
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/siniestros.jpg');"
              >
                <h3 class="imgtitle text-center">{{$t('leasing.l7')}}</h3>
              </b-col>
              <b-col 
              md="4" 
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/asistencia.jpg');"
              >
                <h3 class="imgtitle text-center">{{$t('leasing.l8')}}</h3>
              </b-col>
              <b-col 
              md="4" 
              class="no-padding zoom"
              style="
              max-height: 100%;
              max-width: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-image: url('../img/legales.jpg');"
              >
                <h3 class="imgtitle text-center">{{$t('leasing.l9')}}</h3>
              </b-col>
          </b-row>
        </div>
        <!--  -->
        <br>
        <p class="titlequestion text-center">{{$t('leasing.l10')}}</p>
        <br>
        <div class="cont">

            <b-row class="m-5">

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src="/img/advise-yourself.svg"/>
                <p class="titlesupp">{{$t('leasing.l11')}}</p>
                <p class="textsupp">{{$t('leasing.l12')}}</p>
                </b-col>

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src="/img/costs.svg"/>
                <p class="titlesupp">{{$t('leasing.l13')}}</p>
                <p class="textsupp">{{$t('leasing.l14')}}</p>
                </b-col>

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src="/img/finance.svg"/>
                <p class="titlesupp">{{$t('leasing.l15')}}</p>
                <p class="textsupp">{{$t('leasing.l16')}}</p>
                
                </b-col>

            </b-row>

            <b-row class="m-5">

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src=""/>
                <p class="titlesupp">{{$t('leasing.l17')}}</p>
                <p class="textsupp">{{$t('leasing.l18')}}</p>
                </b-col>

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src=""/>
                <p class="titlesupp">{{$t('leasing.l19')}}</p>
                <p class="textsupp">{{$t('leasing.l20')}}</p>
                </b-col>

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src="/img/clock.svg"/>
                <p class="titlesupp">{{$t('leasing.l21')}}</p>
                <p class="textsupp">{{$t('leasing.l22')}}</p>
                
                </b-col>
                
            </b-row>

            <b-row class="m-5">

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src="/img/operation.svg"/>
                <p class="titlesupp">{{$t('leasing.l23')}}</p>
                <p class="textsupp">{{$t('leasing.l24')}}</p>
                
                </b-col>

                <b-col md class="text-center">
                <img 
                   style="width:100px; heigth:100px"
                   class="" 
                   src="/img/finance.svg"/>
                <p class="titlesupp">{{$t('leasing.l25')}}</p>
                <p class="textsupp">{{$t('leasing.l26')}}</p>
                
                </b-col>

            </b-row>

        </div>

        
        <!-- <div class="row">
          <div class="col-sm-2">

          </div>
          <div class="col-sm-4">
            Nombre
          </div>
          <div class="col-sm-4">
            <center>
                <h1>Cotiza tu Leasing Operativo</h1>
                  
                <vue-recaptcha sitekey="6LdxcG0UAAAAABUBYArbY9C_ftopoatoufQr5JQe">

                </vue-recaptcha>
                
                </center>
          </div>
          <div class="col-sm-2">

          </div>
        </div> -->
        <b-container fluid>
          <b-row>
              <b-col md="6" offset-md="3">
                
                <center><h1>{{$t('leasing.l27')}}</h1></center>
                <br>
                   <form>

                        <div class="form-group row">
                          <label for="name" class="col-sm-3 col-form-label labelForm">{{$t('leasing.l28')}}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" id="name" v-model="contacto_leasing.nombre_empresa" required>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="ruc" class="col-sm-3 col-form-label labelForm">{{$t('leasing.l29')}}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" id="ruc" v-model="contacto_leasing.ruc" required>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="contacto" class="col-sm-3 col-form-label labelForm">{{$t('leasing.l30')}}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" id="contacto" v-model="contacto_leasing.contacto" required>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="tel" class="col-sm-3 col-form-label labelForm">{{$t('leasing.l31')}}</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" id="tel" v-model="contacto_leasing.tel" required>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="email" class="col-sm-3 col-form-label labelForm">{{$t('leasing.l32')}}</label>
                          <div class="col-sm-9">
                            <input type="email" class="form-control" id="email" v-model="contacto_leasing.email" required>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label for="mensaje" class="col-sm-3 col-form-label labelForm">{{$t('leasing.l33')}}</label>
                          <div class="col-sm-9">
                            <textarea class="form-control" id="mensaje" rows="3" v-model="contacto_leasing.mensaje" required></textarea>
                          </div>
                        </div>

                        
                            <center>
                              <div :class="{'recaptcha_fail': !ver_recaptcha}">
                                <vue-recaptcha  
                                            sitekey="6LdxcG0UAAAAABUBYArbY9C_ftopoatoufQr5JQe"
                                            @verify="reVerify">
                                </vue-recaptcha>
                                <small>{{$t('leasing.l35')}}</small>
                              </div>
                            <button type="button" @click.prevent="verifyForm" class="btn btn-success btn-lg">{{$t('leasing.l34')}}</button>
                            </center>
                         
                    </form>
                
              </b-col>
              
          </b-row>
        </b-container>  
            <br><br>
       </div>  
      <!--  -->
        <contactcomp/>
        <mainfooter/>
    </div>
</template>

<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'
import covidnews      from '@/components/covidnews.vue'
import contactcomp    from '@/components/contactcomp.vue'
import VueRecaptcha   from 'vue-recaptcha'
import { mapAction, mapActions, mapState }  from 'vuex'
export default {
    name: 'Leasing',
    metaInfo: {
      title: "Enterprise Panama - Leasing Operativo | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components: {
        masternav,
        mainfooter,
        maincontent,
        rents,
        covidnews,
        contactcomp,
        VueRecaptcha 
    },
    data() {
      return {
        ver_recaptcha: null,
        
      }
    },
    computed: {
      ...mapState(['contacto_leasing'])
    },
    methods: {
      ...mapActions(['sendMailLeasing']),
      reVerify( response ) {

          this.ver_recaptcha = response

      },
      verifyForm()
      {
        if(this.ver_recaptcha)
        {
          if (this.contacto_leasing.nombre_empresa != '' 
            && this.contacto_leasing.ruc != '' 
            && this.contacto_leasing.contacto != ''
            && this.contacto_leasing.tel != ''
            && this.contacto_leasing.email != ''
            && this.contacto_leasing.mensaje != '') {

          // accion envio del formulario
          //console.log("pasaste");
          this.sendMailLeasing()
          //location.reload('/leasing')

        } else {
            alert("Los campos marcados con un (*) son requeridos")
        }
        }else{
          //console.log("no verificado")
        }
      }
    },
}
</script>

<style lang="scss" scoped>
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   /* margin-left: 30px; */
   font-weight: 800;
   color: #181918;
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.imgtitle{
    font-family: 'DIN 2014-ExtraBold', Arial, sans-serif;
    color: #ffffff !important;
    margin-top: 40%;
    text-shadow: 2px 2px 6px #252525;
}
.titleterm{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 18px;
   margin-top: 15px;
   /* margin-left: 0px; */
   font-weight: 500;
   color: #333333;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.no-padding {
  padding-left: 0;
  padding-right: 0;
}
.zoom{
    transition: transform .5s;
}
.zoom:hover {
  -ms-transform: scale(2.05); /* IE 9 */
  -webkit-transform: scale(1.5); /* Safari 3-8 */
  transform: scale(1.05); 
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.form-control{
  
  padding: 1%;
  border: 1px solid #ced4da;
  border-radius: 0px;
  
}
.labelForm
{
  width: 30%;
  display: inline-block;
  font-weight: 600;
  color: #00703c;
}
h1
{
  color: #00703c;
  font-weight: 700;
  width: 100%;
  text-align: center;
}
.btn{
  background-color:  #00703c;
  border-radius: 0px;
  padding: 2%;
  width: 48%;
}
small
{
  visibility: hidden;
}
.recaptcha_fail small
{
  color: red;
}
.cont{
  margin-right: 10%;
  margin-left: 10%;
}
</style>
